/**
 * 投票的两个对话框：主持人发起投票、全体看结果。
 */

import { useState } from 'react'

import { PollLimits } from '../lib/messages'
import { useRoomStore } from '../stores/roomStore'

/** 结果弹层。投票结束时自动出现。 */
export function PollResult() {
  const result = useRoomStore((s) => s.pollResult)
  const close = useRoomStore((s) => s.clearPollResult)
  const members = useRoomStore((s) => s.members)
  if (!result) return null
  const top = Math.max(1, ...result.counts.map((c) => c.count))
  return (
    <div className="dlg-mask" onClick={close}>
      <div className="dlg narrow poll-dlg" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="投票结果">
        <h3>投票结果</h3>
        <p className="poll-q">{result.title}</p>
        <p className="poll-sum">共 {result.voted} 人参与（在场 {result.total} 人）</p>
        <ul className="poll-res-list">
          {result.counts.map((c) => {
            const pct = result.voted > 0 ? Math.round((c.count / result.voted) * 100) : 0
            return (
              <li key={c.index} className={c.count === top && c.count > 0 ? 'win' : ''}>
                <span className="poll-res-txt">
                  {result.options.find((o) => o.index === c.index)?.text ?? `选项 ${c.index + 1}`}
                  <em className="poll-res-num">{c.count} 票 · {pct}%</em>
                </span>
                <span className="poll-bar" style={{ width: `${pct}%` }} />
                {/* 匿名投票服务端不下发 voters，这里自然就不显示 */}
                {c.voters && c.voters.length > 0 && (
                  <span className="poll-voters">
                    {c.voters.map((id) => members.get(id)?.name || `席位 ${id}`).join('、')}
                  </span>
                )}
              </li>
            )
          })}
        </ul>
        <div className="dlg-foot">
          <button className="primary" onClick={close}>知道了</button>
        </div>
      </div>
    </div>
  )
}

/** 发起投票（主持人）。 */
export function PollCompose({ onClose }: { onClose: () => void }) {
  const startPoll = useRoomStore((s) => s.startPoll)
  const [title, setTitle] = useState('')
  const [opts, setOpts] = useState(['', ''])
  const [multi, setMulti] = useState(false)
  const [anonymous, setAnonymous] = useState(false)
  const [liveStat, setLiveStat] = useState(false)

  const valid = title.trim() !== '' && opts.filter((o) => o.trim()).length >= 2
  const submit = () => {
    if (!valid) return
    startPoll(title.trim(), opts.map((o) => o.trim()).filter(Boolean), { multi, anonymous, liveStat })
    onClose()
  }

  return (
    <div className="dlg-mask" onClick={onClose}>
      <div className="dlg narrow poll-dlg" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="发起投票">
        <h3>发起投票</h3>
        <input
          className="poll-in"
          placeholder="题目，例如：这道题的答案是？"
          maxLength={PollLimits.MaxTitleLen}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        {opts.map((o, i) => (
          <div className="poll-opt-row" key={i}>
            <input
              className="poll-in"
              placeholder={`选项 ${i + 1}`}
              maxLength={PollLimits.MaxOptLen}
              value={o}
              onChange={(e) => setOpts((p) => p.map((x, j) => (j === i ? e.target.value : x)))}
            />
            {opts.length > 2 && (
              <button className="poll-del" title="删除这一项" onClick={() => setOpts((p) => p.filter((_, j) => j !== i))}>
                ×
              </button>
            )}
          </div>
        ))}
        {opts.length < PollLimits.MaxOptions && (
          <button className="poll-add" onClick={() => setOpts((p) => [...p, ''])}>
            + 添加选项
          </button>
        )}
        <div className="poll-flags">
          <label className="chk"><input type="checkbox" checked={multi} onChange={(e) => setMulti(e.target.checked)} />可多选</label>
          <label className="chk"><input type="checkbox" checked={anonymous} onChange={(e) => setAnonymous(e.target.checked)} />匿名</label>
          <label className="chk"><input type="checkbox" checked={liveStat} onChange={(e) => setLiveStat(e.target.checked)} />学员可见票数</label>
        </div>
        <div className="dlg-foot">
          <button onClick={onClose}>取消</button>
          <button className="primary" disabled={!valid} onClick={submit}>发起</button>
        </div>
      </div>
    </div>
  )
}
